@if (constant.tenantConstant.constantValues.length > 0) {
  <hr/>
}

<div class="form-row">
  @for (value of constant.tenantConstant.constantValues; track value; let i = $index) {
    <div class="col-12 col-md-6">
      <scitis-admin-organization-constant-value-item
        [parentFormGroup]="parentFormGroup"
        [type]="constant.portalSetting.value"
        [index]="i"
        (removeValueEvent)="onRemoveInterval(i)"
        (dateChangedEvent)="onValueDateChanged()"    >
      </scitis-admin-organization-constant-value-item>
    </div>
  }
</div>

<div class="row">
  <div class="col-12">
    <hr/>
    <button (click)="onAddNewInterval()"
      class="btn btn-primary pull-right">
      <span class="fa-solid fa-plus"></span>
      <span class="hidden-xs" translate>New constant interval</span>
    </button>
  </div>
</div>
